import { instance } from '../index';

//公司关注分析师列表
export const companyAnalystList = async (data, config = {}) => {
  return await instance.post('/api/admin/market-trend-company/company-analyst', data, config);
};

//获取个股财务指标接口
export const queryFinanceIndexDetail = async (data, config = {}) => {
  return await instance.post('/api/admin/stocks/query-finance-index-detail', data, config);
};

//分析师-路演列表
export const analystRoadshowList = async (data, config = {}) => {
  return await instance.post('/api/admin/roadshow/analyst-roadshow/list', data, config);
};

export const queryIndustryTradeDaily = async (data, config = {}) => {
  return await instance.post('/api/admin/industry/trade-daily/list', data, config);
};

//获取行业交易统计列表
export const queryIndustryStatistics = async (data, config = {}) => {
  return await instance.post('/api/admin/industry/count-statistics/list', data, config);
};

//获取题材交易数据列表-K线图
export const queryThemeTradeDaily = async (data, config = {}) => {
  return await instance.post('/api/admin/theme/trade-daily/list', data, config);
};

//获取题材交易统计列表
export const queryThemeStatistics = async (data, config = {}) => {
  return await instance.post('/api/admin/theme/count-statistics-list', data, config);
};

//获取成分股-行业
export const queryIndustryCode = async (data, config = {}) => {
  return await instance.post('/api/admin/industry/industry-code', data, config);
};

//获取成分股-题材
export const queryThemeCode = async (data, config = {}) => {
  return await instance.post('/api/admin/theme/constituent-stock-list', data, config);
};

//获取成分股统计数据-行业
export const queryIndustryCodeChg = async (data, config = {}) => {
  return await instance.get('/api/admin/industry/industry-code-chg', data, config);
};

// 当前最大交易日期时间-行业
export const industryTradeDay = async (data, config = {}) => {
  return await instance.get('/api/admin/industry/max-trade-day', data, config);
};

// 当前最大交易日期时间-题材
export const themeTradeDay = async (data, config = {}) => {
  return await instance.get('/api/admin/theme/max-trade-day', data, config);
};

// 题材列表
export const themeLsit = async (data, config = {}) => {
  return await instance.post('/api/admin/theme/list', data, config);
};

// 热门题材
export const themeHotThem = async (data, config = {}) => {
  return await instance.get('/api/admin/theme/hot-them', data, config);
};

// 关注取消题材
export const themeOperate = async (data, config = {}) => {
  return await instance.post('/api/admin/theme/theme-operate', data, config);
};

// 用户自选题材
export const themeUserTheme = async (data, config = {}) => {
  return await instance.post('/api/admin/theme/user-theme', data, config);
};

// 获取热门个股列表-题材
export const queryThemeHotStock = async (data, config = {}) => {
  return await instance.post('/api/admin/theme/hot-stock-list', data, config);
};

//获取个股财务指标列表
export const queryStockFinance = async (data, config = {}) => {
  return await instance.post('/api/admin/stocks/query-finance-index-list', data, config);
};

//获取个股每日交易数据列表
export const queryStockTradeDaily = async (data, config = {}) => {
  return await instance.post('/api/admin/stock/trade-daily/list', data, config);
};

//获取个股交易统计列表
export const queryStockStatistics = async (data, config = {}) => {
  return await instance.post('/api/admin/stock/count-statistics/list', data, config);
};

//获取个股每周交易数据列表-新
export const queryStockTradeWeeklyNew = async (data, config = {}) => {
  return await instance.post('/api/admin/stock/trade-weekly/list', data, config);
};

//获取个股每月交易数据列表-新
export const queryStockTradeMonthlyNew = async (data, config = {}) => {
  return await instance.post('/api/admin/stock/trade-monthly/list', data, config);
};
